<template>
  <div class="lessonview mr-4">
    <div class="ml-4">

      <div class="my-6">
        <div
          v-for="field in fieldList"
          :key="field.model"
          v-bind:class="field.model"
        >
          <div v-if="hasContent(field.model)">
            <section class="lesson-hero" v-if="field.model == 'outline'">
              <div class="lesson-hero__left">
                <h1>{{lesson.name}}</h1>
                <p>Lesson content, resources and plan.</p>

                  <div
                      @click="showPopupScreen(field.model)"
                      class="intro-button text-center text-sm text-white bg-orange-300 rounded cursor-pointer hover:bg-orange-500"
                    >
                      <i class="fas fa-arrow-alt-circle-right"></i> View
                      {{ popupTitle(field.model) }}
                    </div>

              </div>

              <div class="lesson-hero__outcomes">
                <div
                  v-html="parseContent(field.model)"
                  class="section-content text-justify"
                ></div>
              </div>
            </section>

            <div v-else-if="field.model == 'main-session' && layoutType == 'file'">
              <dynamicfile
                :url="loadFile()"
                :name="fileTitle()"
                class=""
                v-bind:class="isOakAcademy ? 'w-11/12' : 'w-full'"
              ></dynamicfile>

              <div class="mb-4 mt-8 flex w-full" v-if="videosLoaded">
                <div
                  class="video mr-4 mb-4"
                  v-for="video in showVideoList(field.model)"
                  :key="video.identifier"
                >
                  <iframe
                    class="sproutvideo-player"
                    v-bind:src="videoURL(video)"
                    frameborder="0"
                    scrolling="no"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
            <div
              v-else
              class="w-full border border-gray-200 rounded-lg p-4 mb-4"
            >
              <div
                v-if="showTitle(field.model)"
                class="flex pb-2 mb-4 border-b-2 border-list-grey border-solid"
              >
                <h4 class="text-base font-bold w-6/12 flex">
                  <div v-html="setSectionTitle(field)" />
                  <button
                    v-if="!hasDocument"
                    @click="showLessonAltered(field)"
                    class="ml-6 text-sm text-action-blue hover:opacity-50 focus:outline-none"
                  >
                    <i class="fas fa-edit"></i>
                    edit
                  </button>
                </h4>

                <div class="w-9/12 flex justify-end" v-if="diagramsLoaded">
                  <lessonResources :resources="documentFilter(field.model)">
                  </lessonResources>
                </div>
              </div>

              <div class="flex flex-row">
                <div v-if="field.model == 'main-session' && hasDocument">
                  <div class="mb-4 mt-8 flex w-full" v-if="videosLoaded">
                    <div
                      class="video mr-4 mb-4"
                      v-for="video in showVideoList(field.model)"
                      :key="video.identifier"
                    >
                      <iframe
                        class="sproutvideo-player"
                        v-bind:src="videoURL(video)"
                        frameborder="0"
                        scrolling="no"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>

                  <dynamicfile
                    :url="loadFile()"
                    :name="fileTitle()"
                    class="w-full"
                  ></dynamicfile>
                </div>

                <div
                  v-else
                  v-bind:class="showDiagram(field.model) ? 'w-3/4' : ''"
                >
                  <div
                    v-html="parseContent(field.model)"
                    class="section-content text-justify"
                  ></div>

                  <div
                    class="flex content-end m-4 mb-3 ml-6"
                    v-if="hasPopupContent(field.model)"
                  >
                    <div
                      @click="showPopupScreen(field.model)"
                      class="intro-button text-center text-sm text-white bg-orange-300 rounded cursor-pointer hover:bg-orange-500"
                    >
                      <i class="fas fa-arrow-alt-circle-right"></i> View
                      {{ popupTitle(field.model) }}
                    </div>

                    <div class="ml-4">
                      <lessonResources
                        :resources="documentFilter(field.model)"
                        :popupDown="true"
                      >
                      </lessonResources>
                    </div>
                  </div>

                  <div class="mb-4 mt-8 flex w-full" v-if="videosLoaded">
                    <div
                      class="video mr-4 mb-4"
                      v-for="video in showVideoList(field.model)"
                      :key="video.identifier"
                    >
                      <iframe
                        class="sproutvideo-player"
                        v-bind:src="videoURL(video)"
                        frameborder="0"
                        scrolling="no"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>

                <div
                  class="diagrams w-1/4 pl-8"
                  v-if="diagramsLoaded"
                  v-show="showDiagram(field.model)"
                >
                  <div
                    v-for="(pic, index) in diagramFilter(field.model)"
                    :key="index"
                    class="mb-2"
                  >
                    <dynamicimage
                      :url="loadDiagram(pic)"
                      :reference="'ref_' + index"
                      :name="pic.title"
                    ></dynamicimage>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popupScreen
      :title="selectedPopupTitle"
      :content="selectedPopupContent"
      :videos="selectedPopupVideos"
      :diagrams="selectedPopupDiagrams"
      @close="showPopupModal = false"
      v-if="showPopupModal"
      v-show="showPopupModal"
    ></popupScreen>

    <ModalSlide
      v-if="selectedEditField != undefined"
      :show="showLessonAlteredModal"
      @closeModal="showLessonAlteredModal = false"
    >
      <template v-slot:header-icon>
        <i class="fas fa-edit"></i>
      </template>
      <template v-slot:header-title>
        Lesson Alteration @ {{ selectedEditField.name }}
      </template>
      <template v-slot:body>
        <LessonAltered
          @refresh="refreshLesson"
          :displayField="selectedEditField"
          :lesson="lesson"
          :altered="alteredLessonSection"
          :key="'altering' + lesson.id"
        ></LessonAltered>
      </template>
    </ModalSlide>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { lessonContentMixin } from "@/mixins/lessonContentMixin.js";

import { SchoolService } from "@/services/school.service";

const dynamicimage = () => import("@/components/DynamicImage.vue");
const dynamicfile = () => import("@/components/DynamicFile.vue");
const popupScreen = () => import("@/components/LessonContentModal.vue");
const LessonAltered = () =>
  import("@/components/curriculum/TheLessonAltered.vue");

const lessonResources = () => import("@/components/curriculum/LessonResources.vue");

export default {
  name: "lessonview",
  mixins: [lessonContentMixin],
  props: {
    course: Object,
    pupils: Array,
    lesson: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    description() {
      return "Lesson content, resources and plan.";
    },
    videosLoaded() {
      return this.videos.length > 0;
    },
    diagramsLoaded() {
      return this.resources.length > 0;
    },
    layoutType() {
      return this.lesson.layout;
    },
    hasDocument() {
      return (
        this.layoutType != undefined &&
        this.layoutType.length != 0 &&
        this.lesson.document_url != null &&
        this.lesson.document_url.length > 3
      );
    },
    isOakAcademy() {
      return this.course.category.key_value;
    },
  },
  data() {
    return {
      errored: false,
      showPopupModal: false,
      videos: [],
      resources: [],
      selectedPopupTitle: "",
      selectedPopupContent: "",
      selectedPopupVideos: [],
      selectedPopupDiagrams: [],

      showAttendanceModal: false,
      showPostsModal: false,

      lessonFiles: [],
      showResourcesModal: false,

      alteredList: [],
      alteredLessonSection: undefined,
      selectedEditField: undefined,
      showLessonAlteredModal: false,
      warmUpExpanded: true,
      activeTab: 'outline'

    };
  },
  created() {
    this.fetchAltered();
  },
  mounted() {
    this.fetchVideos();
    this.fetchResources();
  },
  methods: {
    fetchAltered() {
      SchoolService.getAll("lessons/" + this.lesson.id + "/altered")
        .then((response) => (this.alteredList = response.data.data))
        .catch((err) => {
          console.log(" alterd" + err);
          this.errored = true;
        })
        .finally(() => (this.errored = false));
    },
    fetchVideos() {
      SchoolService.getAll("lessons/" + this.lesson.id + "/videos")
        .then((response) => this.buildVideoList(response.data.data))
        .catch((err) => {
          console.log(" videos" + err);
          this.errored = true;
        })
        .finally(() => (this.errored = false));
    },
    buildVideoList(data) {
      this.videos = data;
    },
    fetchResources() {
      SchoolService.getAll("lessons/" + this.lesson.id + "/resources")
        .then((response) => this.buildResourceList(response.data.data))
        .catch((err) => {
          console.log(" resources" + err);
          this.errored = true;
        })
        .finally(() => (this.errored = false));
    },
    buildResourceList(data) {
      this.resources = data;
      this.lessonFiles = this.resources.filter(function (r) {
        return r.format != "diagram";
      });
      if (
        this.course.category.key_value != "concept" &&
        (this.lesson.document_url != null || this.lesson.document_url != "") &&
        ["file", "fields"].includes(this.lesson.layout)
      ) {
        const document = {
          format: "teaching",
          title: this.lesson.name + " session",
          url: this.lesson.document_url,
          display_order: 1,
        };
        this.lessonFiles.push(document);
      }
    },
    showLessonAltered(field) {
      this.selectedEditField = field;
      this.alteredLessonSection = this.findAlteredLesson(field.model);
      this.showLessonAlteredModal = true;
    },
    refreshLesson() {
      this.showLessonAlteredModal = false;
      this.fetchAltered();
      this.$forceUpdate();
    },
    findAlteredLesson(section) {
      return this.alteredList.find((al) => {
        if (al.share_level > 0) {
          return (
            al.display_key === section &&
            al.user_id === this.currentUser.teacherID
          );
        } else {
          return al.display_key === section;
        }
      });
    },
    getContent(section) {
      let altered = this.findAlteredLesson(section);
      return this.processContent(section, this.lesson, altered);
    },
    videoFilterList(section) {
      return this.videos.filter((v) => {
        var filtered = true;

        console.log("SECTUION", section);

        if (section.trim() === "outline") {
          filtered = ["outline", "objective"].includes(v.display_key);
        } else {
          filtered = v.display_key == section.trim();
        }

        return filtered;
      });
    },
    videoFilter(section) {
      return this.videoFilterList(section);
    },
    diagramFilter(section) {
      return this.resources.filter((v) => {
        return v.display_key == section && v.format == "diagram";
      });
    },
    documentFilter(section) {
      return this.resources.filter((v) => {
        var filtered = true;

        filtered = v.format == "document";

        if (filtered) {
          if (section === "outline") {
            filtered = ["outline", "introduction"].includes(v.display_key);
          } else {
            filtered = v.display_key == section;
          }
        }

        return filtered;
      });
    },
    hasContent(section) {
      if (section === "main-session" && this.layoutType == "file") {
        return true;
      } else if (section === "main-session" && this.hasDocument) {
        return true;
      } else {
        return this.getContent(section).length != 0;
      }
    },
    hasPopupContent(section) {
      switch (section) {
        case "outline":
          return (
            this.lesson.introduction != null &&
            this.lesson.introduction.length > 0
          );
        case "main-session":
          return (
            this.lesson.activities != null && this.lesson.activities.length > 0
          );
        default:
          return false;
      }
    },

    showPopupScreen(section) {
      if (["outline", "main-session"].includes(section) === false) {
        return;
      }

      let title =
        section === "outline" ? "Introduction" : "Additional Activities";
      this.selectedPopupTitle = this.lesson.name + " " + title;

      let contentSection = section == "outline" ? "introduction" : "activities";
      this.selectedPopupContent = this.parseContent(contentSection);
      this.selectedPopupVideos = this.videoFilterList(contentSection);
      this.selectedPopupDiagrams = this.diagramFilter(contentSection);
      this.showPopupModal = true;
    },
    setSectionTitle(field) {
      let altered = this.findAlteredLesson(field.model);
      return this.processSectionTitle(
        this.course.subject_id,
        field,
        this.lesson,
        altered
      );
    },
    showVideoList(value) {
      return this.videoFilter(value);
    },
    showDiagram(value) {
      return this.diagramFilter(value)[0] != undefined;
    },
    loadDiagram(diagram) {
      return diagram.folder + "/" + diagram.url;
    },
    loadFile() {
      return this.lesson.document_url;
    },
    fileTitle() {
      return this.lesson.name;
    },
    videoURL(video) {
      return (
        video.service_url_b +
        "?autoPlay=false&amp;playerTheme=dark&amp;playerColor="
      );
    },
  },
  components: {
    dynamicimage,
    dynamicfile,
    popupScreen,
    LessonAltered,
    lessonResources
  },
};
</script>

<style scoped>
.video {
  width: 610px;
  height: 345px;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  border: 2px solid #3e4448;
  background-color: #3e4448;
}

.video iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

h1 {
  @apply text-lg font-bold;
}

.outline .section-content h2 {
  margin-top: 1rem !important;
}

.lesson-tabs {
  display: flex;
  align-items: stretch;

  min-height: 56px;

  padding: 0 18px;
  background: #fff;

  overflow-x: auto;
}

.lesson-tabs {
  @apply border-b-2 border-gray-100;
}

.lesson-tab {
  position: relative;

  display: inline-flex;
  align-items: center;
  gap: 10px;

  min-width: 145px;
  padding: 0 22px;

  border: 0;

  background: transparent;
  color: #5d6580;

  font-size: 15px;
  font-weight: 500;

  cursor: pointer;
}

.lesson-tab::after {
  content: "";

  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  height: 3px;

  background: transparent;
}

.lesson-tab:hover {
  @apply text-purple-400;
}

.lesson-tab--active {
  @apply text-purple-600 font-bold;
}

.lesson-tab__icon {
  font-size: 19px;
}

/* Hero */

.lesson-hero {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);

  margin-top: 18px;

  overflow: hidden;

  border-radius: 16px;

  background: linear-gradient(135deg, #faf9ff 0%, #f5f2ff 100%);

  box-shadow: var(--shadow);
  margin-bottom: 20px;
  padding: 20px;
}

.lesson-hero__left {
  position: relative;

  padding: 0;

  overflow: hidden;
}

.lesson-hero__left h1 {
  margin: 0;

  font-size: 34px;
  line-height: 1.1;
}

.lesson-hero__left p {
  margin: 6px 0 28px;

  color: var(--muted);

  font-size: 13px;
}

.intro-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  min-height: 46px;
  padding: 0 20px;

  border: 0;
  border-radius: 10px;

  color: #fff;

  background: linear-gradient(90deg, #ff4b55 0%, #ff514b 100%);

  box-shadow: 0 8px 18px rgba(255, 78, 80, 0.2);

  font-size: 14px;
  font-weight: 700;

  cursor: pointer;
}

.intro-button:hover {
  transform: translateY(-1px);
}

.intro-button__play {
  width: 22px;
  height: 22px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  color: #ff5353;
  background: #fff;

  font-size: 10px;
}

.lesson-card {
  margin-top: 20px;

  overflow: hidden;

  border: 1px solid var(--border);
  border-radius: 15px;

  background: #fff;

  box-shadow: var(--shadow);
}

.lesson-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  min-height: 64px;
  padding: 0 18px;

  border-bottom: 1px solid #edf0f4;
}

.lesson-card__title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.lesson-card__title h2 {
  margin: 0;

  font-size: 18px;
}

.section-icon {
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  color: var(--purple);
  background: #f3efff;

  font-size: 18px;
}

.lesson-card__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

@media (max-width: 600px) {
  .lesson-tabs {
    padding: 0 8px;
  }

  .lesson-tab {
    min-width: auto;
    padding: 0 15px;
  }

  .lesson-tab__icon {
    display: none;
  }

  .outcome-row {
    grid-template-columns: 50px minmax(0, 1fr);
  }

  .outcome-icon {
    width: 50px;
    height: 50px;

    border-width: 5px;

    font-size: 21px;
  }
}
</style>
